<template>
<div style="background: #FCFBFC">
  <dss-card class="index-model-3" style="margin-top: 80px" :wrap-width="wrapWidth" title="经典案例">
    <div style="margin-top: 60px">
      <div class="title">
        <div class="d-flex justify-center align-center">
          <v-img :src="ImageIcon1" contain width="37"></v-img>
          {{ title }}</div>
        <div>
          <arrow-left theme="outline" size="40" :fill="activeKey !== 0 ? '#7883e6' : '#bdb6bd'" style="cursor: pointer" @click="handleOnClick('minus')"/>
          <arrow-right theme="outline" size="40" :fill="activeKey !== 2 ? '#7883e6' : '#bdb6bd'" style="cursor: pointer" @click="handleOnClick('add')"/>
        </div>
      </div>

      <div style="margin-top: 30px">
        <!--案例一-->
        <div v-if="activeKey === 0">
          <div class="d-flex justify-space-between caseContent">
            <div class="caseLeft">
              <div>
                <v-img :src="CaseLeft"></v-img>
              </div>

              <div class="caseLeftText">
                <ul>
                  <li>遗传代谢病串联质谱筛查中80余种指标的分析解读</li>
                  <li>基于多种指标的结果组合预测60多种新生儿遗传代谢病风险</li>
                  <li>进一步诊疗建议</li>
                </ul>
              </div>
            </div>
            <div class="caseRight">
              <div class="caseRightText">
                <ul>
                  <li>与某顶级三甲医院合作</li>
                  <li>获得四川省科技厅重点项目支持</li>
                  <li>已成果转化至30余家医院</li>
                  <li>被地市卫健委专项基金采购</li>
                </ul>
              </div>
              <div>
                <v-img :src="CaseRight"></v-img>
              </div>
            </div>
          </div>
        </div>
        <!--案例二 基于知识图谱的糖尿病营养膳食管理工具-->
        <div v-if="activeKey === 1">
          <div>
            <div class="d-flex justify-space-between">
              <div
                v-for="al1Item in al1"
                :key="al1Item.id"
                style="width: 19%; "
                class="pa-3"
              >
                <v-img :src="al1Item.image"></v-img>
                <v-img
                  :src="al1Item.titleImage"
                  width="49px"
                  height="43px"
                  style="margin: auto"
                  class="mt-11 mb-9"
                />
                <div class="text-center" style="white-space: break-spaces;color: #656A72">{{ al1Item.content }}</div>
              </div>
            </div>
          </div>
        </div>
        <!--案例三-->
        <div v-if="activeKey === 2">
          <div>
            <div>
              <div class="im5-al2-card-title">生成报告--报告解读-日趋势图</div>
              <div style="margin-top: 68px">
                <v-img :src="ImageAL1" contain/>
              </div>
            </div>
            <div class="im5-al2-card px-8">
              <div class="im5-al2-card-title">生成报告--问题分析与改善建议</div>
              <div class="im5-al2-card-content">
                <v-row class="ma-0">
                  <v-col :cols="8" class="pl-0">
                    <div v-for="al2Item in al2.left" :key="al2Item.id">
                      <div class="im5cc-left-title px-4">{{ al2Item.title }}</div>
                      <div class="py-4">
                        <template v-for="al2cItem in al2Item.content">
                          <div :key="al2cItem.id" class="d-flex im5cc-left-content">
                            <div class="px-4" style="width: 30%;">{{ al2cItem.title }}</div>
                            <div class="px-2"/>
                            <div class="px-4 pb-3" style="width: 70%;background-color: #F7F7F7">{{ al2cItem.text }}</div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </v-col>
                  <v-col :cols="4">
                    <div class="im5cc-left-title px-4" style="background-color: transparent;color: #24344B;">问题分析与改善建议</div>
                    <ul class="py-4" style="color: #656A72">
                      <li style="line-height: 32px; margin-bottom: 45px">
                        通过数据分析，识别出“低血糖风险”“血糖波动”“体重偏轻”等风险事件，依据《共识》给出改善建议。结合整体情况，给出饮食建议、运动建议。
                      </li>
                      <li style="line-height: 32px">结合整体情况，给出饮食建议、运动建议。</li>
                    </ul>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </dss-card>
</div>
</template>
<script>
import ImageIcon1 from '../../../../assets/pc/index/dss/组 23.png'
import DssCard from '../dss/dss-card.vue'
import {ArrowRight, ArrowLeft} from '@icon-park/vue'
import ImageIphone1 from '../../../../assets/pc/index/dss/iphone-左1.png'
import ImageXT from '../../../../assets/pc/index/dss/血糖水平的实时监控 .png'
import ImageIphone2 from '../../../../assets/pc/index/dss/iphone-左2.png'
import ImageMR from '../../../../assets/pc/index/dss/每日食物摄入量 总情况跟踪.png'
import ImageIphone3 from '../../../../assets/pc/index/dss/iphone-左3.png'
import ImageTS from '../../../../assets/pc/index/dss/提示规则触发(摄入量提示_检测提示_血糖值监测) .png'
import ImageIphone4 from '../../../../assets/pc/index/dss/iphone-左4.png'
import ImageZN from '../../../../assets/pc/index/dss/智能食谱推荐_ 功能性食品推荐 .png'
import ImageIphone5 from '../../../../assets/pc/index/dss/iphone-左5.png'
import ImageJK from '../../../../assets/pc/index/dss/健康教育 .png'
import ImageAl34 from '../../../../assets/pc/index/dss/案例3-1.png'
import ImageAl31 from '../../../../assets/pc/index/dss/案例3-2.png'
import ImageAl32 from '../../../../assets/pc/index/dss/案例3-3.png'
import ImageAl33 from '../../../../assets/pc/index/dss/案例3-4.png'
import CaseLeft from '../../../../assets/pc/index/smart/case-left.png'
import CaseRight from '../../../../assets/pc/index/smart/case-right.png'
import ImageAL1 from '../../../../assets/pc/index/dss/1.png'
export default{
  name: 'cooperation-new-case',
  components: {DssCard, ArrowRight, ArrowLeft},
  data: () => {
    return {
      ImageIcon1,
      ImageAL1,
      CaseLeft,
      CaseRight,
      activeKey: 0,
      title: '案例一：新生儿遗传代谢病早筛系统',
      al1: [
        { id: 1, image: ImageIphone1, titleImage: ImageXT, content: '血糖水平的实时监控' },
        { id: 2, image: ImageIphone2, titleImage: ImageMR, content: '每日食物摄入量\n总情况跟踪' },
        {
          id: 3,
          image: ImageIphone3,
          titleImage: ImageTS,
          content: '提示规则触发     \n (摄入量提示/检测提示/血糖值监测)\n'
        },
        { id: 4, image: ImageIphone4, titleImage: ImageZN, content: '智能食谱推荐/\n功能性食品推荐\n' },
        { id: 5, image: ImageIphone5, titleImage: ImageJK, content: '健康内容' }
      ],
      al2: {
        left: [
          {
            id: 1,
            title: '目前需要关注的问题',
            content: [
              { id: 1, title: '问题 1', text: '低血糖风险' },
              { id: 2, title: '危害/风险', text: '严重低血糖会出现神志不清，甚至昏迷危及生命。' },
              {
                id: 3,
                title: '改善建议',
                text: '1.改善饮食结构，调整进餐时间，增加蛋白质摄入，控制高热量食物摄入，少吃多餐；2.在专科医生指导下调整胰岛素剂量；3.注意监测血糖；4.随身携带糖果、饼干，遇到心慌、浑身冷汗、饥饿感等低血糖症状时，及时食用，以应对突发低血糖。'
              }
            ]
          },
          {
            id: 2,
            title: '目前需要关注的问题',
            content: [
              { id: 1, title: '问题 2', text: '血糖波动' },
              {
                id: 2,
                title: '危害/风险',
                text: '血糖波动频繁说明患者的病情没有得到满意的控制，会加重病情，加重动脉粥样硬化，导致大血管或微血管出现慢性并发症。血糖波动是糖尿病并发症发生发展的重要原因。'
              },
              {
                id: 3,
                title: '改善建议',
                text: '1.三餐适当控制餐量，尽量少馒头、膨化食品、炸糕等容易升高血糖的食物；少吃多餐，调整用餐时间，避免低血糖的情况出现；2.适当运动，例如慢跑、快步走等，利于降低餐后血糖；3.建议夜间尽量减少进食，以避免夜间血糖偏高；4.建议内分泌专科就诊，是否需要调整胰岛素剂量。'
              }
            ]
          },
          {
            id: 3,
            title: '目前需要关注的问题',
            content: [
              { id: 1, title: '问题 3', text: '视网膜轻微出血' },
              { id: 2, title: '危害/风险', text: '严重视网膜出血可导致视网膜剥脱甚至失明。' },
              {
                id: 3,
                title: '改善建议',
                text: '努力将血糖控制好，保持血糖平稳，延缓并发症的进展；定期到医院眼科复查；注意休息，不要长时间看书、看报、看电视，避免过度兴奋和疲劳，保持良好和充足的睡眠。不要吃刺激性食物，禁喝咖啡和浓茶。'
              }
            ]
          }
        ]
      },
      al3: [
        { id: 1, text: '智能理赔客户端', image: ImageAl34 },
        { id: 2, text: '智能录入', image: ImageAl31 },
        { id: 3, text: '智能核赔', image: ImageAl32 },
        { id: 4, text: '智能辅助作业系统', image: ImageAl33 }
      ],
      al3Image: ImageAl34
    }
  },
  methods: {
    handleOnClick (operation) {
      console.log('this.activeKey', this.activeKey)
      if (operation === 'minus') {
        if (this.activeKey === 0) {
          return
        }
        this.activeKey -= 1
      } else if (operation === 'add') {
        if (this.activeKey === 2) {
          return
        }
        this.activeKey += 1
      }
      this.handleOnChangeTitle()
    },
    handleOnChangeTitle () {
      switch (this.activeKey) {
        case 0:
          this.title = '案例一：新生儿遗传代谢病早筛系统'
          break
        case 1:
          this.title = '案例二：基于知识图谱的糖尿病营养膳食管理工具'
          break
        case 2:
          this.title = '案例三：基于智能决策引擎的血糖动态监测指标解读与改善建议'
          break
      }
    }
  },
  props: {
    wrapWidth: {
      type: Number,
      default: 0
    }
  }
}
</script>
<style scoped>
.title {
  display: flex;
  justify-content: space-between;
}
/* index model 5 - 案例 2 */
#im5-al2 {
  margin-top: 120px;
}

.im5-al2-card {
  margin-top: 90px
}

.im5-al2-card-title {
  font-size: 16px;
  color: #333
}

.im5-al2-card-content {
  margin-top: 68px
}

/* im5cc: index model 5 card content */
.im5cc-left-title {
  font-size: 18px;
  background-color: #D5DDF0;
}

.im5cc-left-content {
  min-height: 32px;
  line-height: 32px
}

.im5cc-left-content div {
  background-color: #F7F7F7
}

.im5cc-left-content > div:first-child {
  width: 30%
}

.im5cc-left-content > div:nth-child(2) {
  background-color: transparent
}

.im5cc-left-content > div:last-child {
  width: 70%
}

/* index model 5 - 案例 3 */
#im5-al3 {
  margin-bottom: 120px
}

.im5-al3-title {
  height: 50px;
  font-size: 16px;
  position: relative;
  transition: left 0.5s ease;
  left: 30px;
}

.im5-al3-title-hover {
  left: -13px;
  color: #376AFF;
}

.im5-al3-hr {
  position: absolute;
  top: 18px;
  left: -24px;
  height: 30px;
  background-color: #376AFF;
  width: 4px
}

.im5-al3-image {
  width: 80%;
  height: 100%;
  background-position: center;
  margin-left: 140px;
  background-size: contain;
}
.caseContent{
  width: 100%;
}
.caseLeft{
  width: 49%;
}
.caseLeftText {
  height: 300px;
  display: flex;
  justify-content: center;
  margin-top: 40px;
  align-items: center;
  color: #878FA7;
}
.caseRight{
  width: 49%;
}
.caseRightText {
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  color: #878FA7;
}
li {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/pc/home/prodCore/cooperation-new-case.vue